<template>
  <svg
    :width="size"
    :height="size"
    :viewBox="`0 0 ${size} ${size}`"
    fill="none"
    fill-rule="nonzero"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.183 7.755l6.202-6.201a.629.629 0 0 0-.888-.889L7.295 6.867 1.093.665a.629.629 0 0 0-.889.889l6.202 6.201-6.202 6.202a.629.629 0 1 0 .889.889l6.202-6.202 6.202 6.202a.629.629 0 1 0 .888-.889L8.183 7.755z"
      :fill="color"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
